import { render, staticRenderFns } from "./ServiceModal.vue?vue&type=template&id=af676ed8"
import script from "./ServiceModal.vue?vue&type=script&lang=js"
export * from "./ServiceModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports